import {Stack} from '@mui/material';
import React from 'react';

import {StyledCard} from 'presentation/components/StyledCard';
import {PrefixTestEnum} from 'presentation/constants/PrefixTestEnum';
import {AttachmentCard} from '../UploadAttachmentCard';
import {CardFooter} from './components/CardFooter';
import {InstructionsAlertInfo} from './components/InstructionsAlertInfo';
import {useAppointmentCard} from './hooks/useAppointmentCard';
import {AppointmentCardContainer} from './styles';
import {AppointmentCardProps} from './types';
import {FavoriteDoctorsLikeButton} from 'presentation/modules/booking/favoriteDoctors/components/FavoriteDoctorsLikeButton';
import {useHostName} from 'presentation/hooks';
import {NotredameAppointmentCard} from './components/NotredameAppointmentCard';

export function AppointmentCard({
	appointment,
	hasFavoriteButton,
	hasTutorialLikeButtonId,
	isFavoriteButtonDisabled,
}: AppointmentCardProps) {
	const {
		palette,
		isLaptop,
		iconName,
		isTelehealth,
		showEnterRoom,
		appointmentDateString,
		CONTENT_LIST,
		isUploadFileTeleFeatureFlagEnabled,
		hideFavoriteButton,
	} = useAppointmentCard(appointment);

	const {isNotredameSaude} = useHostName();

	return isNotredameSaude ? (
		<NotredameAppointmentCard
			hasFavoriteButton={hasFavoriteButton}
			id={hasTutorialLikeButtonId ? 'seeHistoryDetailsLikeButton' : undefined}
			isFavoriteButtonDisabled={isFavoriteButtonDisabled}
			appointment={appointment}
		/>
	) : (
		<AppointmentCardContainer
			elevation={isLaptop ? 0 : 1}
			data-testid={`${PrefixTestEnum.CARD}${appointment.bookingType}`}>
			<StyledCard.Header
				gap={0.5}
				iconProps={{
					customIconName: isTelehealth ? 'smartphone-filled' : iconName,
					variant: 'primary',
					size: 'smaller',
				}}
				title={appointmentDateString}
				titleColor={palette.grey[900]}
				titleTypographyProps={{
					fontSize: '1rem',
					fontWeight: 600,
				}}
			/>

			<Stack
				flex={1}
				flexDirection="row"
				justifyContent="space-between"
				alignItems="flex-start">
				<StyledCard.Content
					list={CONTENT_LIST}
					sx={{flexDirection: 'column', gap: 2}}
					switchFirstTwoListItemsPosition
				/>
				{hasFavoriteButton && (
					<FavoriteDoctorsLikeButton
						cdPrestador={Number(appointment.cdPrestador)}
						cdEspecialidade={Number(appointment.specialtyCode)}
						cdSubEspecialidade={Number(appointment.subSpecialtyCode)}
						selected={appointment.isFavorite}
						hideButton={hideFavoriteButton}
						id={hasTutorialLikeButtonId ? 'seeHistoryDetailsLikeButton' : undefined}
						disabled={isFavoriteButtonDisabled}
					/>
				)}
			</Stack>

			<InstructionsAlertInfo
				bookingType={appointment.bookingType}
				specialtyCode={appointment.specialtyCode}
				specialtyName={appointment.specialtyName}
			/>

			{isUploadFileTeleFeatureFlagEnabled &&
			isTelehealth &&
			appointment?.acceptsAttachment ? (
				<AttachmentCard appointment={appointment} />
			) : null}

			<CardFooter appointment={appointment} showEnterRoom={showEnterRoom} />
		</AppointmentCardContainer>
	);
}
